var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,52.784v406.433h512V52.784H0z M496.165,443.381H15.835v-61.683l203.347-132.175l100.78,61.581l176.203,107.686V443.381    z M496.165,400.233L336.9,302.905l62.477-58.015l96.788,62.913V400.233z M496.165,288.916l-98.512-64.033l-74.788,69.445    l-103.944-63.522L15.835,362.813V68.619h480.33V288.916z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.144,95.01c-34.926,0-63.34,28.414-63.34,63.34s28.414,63.34,63.34,63.34c34.926,0,63.34-28.414,63.34-63.34    S341.07,95.01,306.144,95.01z M306.144,205.856c-26.194,0-47.505-21.311-47.505-47.505s21.311-47.505,47.505-47.505    s47.505,21.311,47.505,47.505S332.339,205.856,306.144,205.856z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.711,131.959c-3.387,0-6.733,0.517-9.961,1.525c-4.785-13.191-17.443-22.639-32.266-22.639    c-14.154,0-26.688,8.76-31.827,21.543c-16.344,2.614-28.874,16.812-28.874,33.88c0,18.918,15.392,34.309,34.309,34.309h68.619    c18.918,0,34.309-15.392,34.309-34.309S174.629,131.959,155.711,131.959z M155.711,184.743H87.093    c-10.186,0-18.474-8.288-18.474-18.474c0-9.697,7.508-17.673,17.035-18.418l7.698,3.849l2.033-10.165    c1.721-8.608,9.333-14.854,18.099-14.854c10.186,0,18.474,8.288,18.474,18.474v15.791l12.62-9.314    c3.45-2.546,7.195-3.836,11.133-3.836c10.186,0,18.474,8.288,18.474,18.474S165.898,184.743,155.711,184.743z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 292.96,
    y: 241.839,
    transform: "matrix(0.5226 -0.8526 0.8526 0.5226 -144.3615 417.7931)",
    width: 15.835,
    height: 191.924,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 419.627,
    y: 268.513,
    transform: "matrix(0.5433 -0.8396 0.8396 0.5433 -75.0269 505.9926)",
    width: 15.836,
    height: 106.882,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 414.351,
    y: 100.289,
    width: 36.948,
    height: 15.835,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440.742,
    y: 137.237,
    width: 36.948,
    height: 15.835,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.588,
    y: 95.01,
    width: 36.948,
    height: 15.835,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197.938,
    y: 105.567,
    width: 36.948,
    height: 15.835,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.588,
    y: 274.474,
    width: 36.948,
    height: 15.835,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.371,
    y: 232.247,
    width: 36.948,
    height: 15.835,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 387.959,
    y: 168.907,
    width: 36.948,
    height: 15.835,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#A7A7A7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.73b9fb31c2acdc0233ff127f0819671c.svg";
export { ForwardRef as ReactComponent };